<div *ngIf="loading" class="text-center">
  <p-progressSpinner></p-progressSpinner>
</div>
<!-- form -->
<form *ngIf="!loading" [formGroup]="form" class="validated-form">

  <div class="field grid">
    <label class="col-fixed">Document File Store Root Path</label>
    <div class="col-fixed inputfield">
      <input class="form-control" name="FileStoreRoot" id="FileStoreRoot" pInputText
             formControlName="fileStoreRoot"/>
      <div class="config-validation-message" [hidden]="!form.controls['fileStoreRoot']?.errors?.maxlength">
        Must be
        shorter than 260 characters
      </div>
      <div class="config-validation-message" [hidden]="!form.controls['fileStoreRoot']?.errors?.invalidFilePath">
        Document File Store Path is invalid
      </div>
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed">Categories</label>
      <mojo-pma-document-centre-category-editor></mojo-pma-document-centre-category-editor>
  </div>
</form>
